/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      component (per-participant ski-level color-picker actions)
 *   extends:   Component (@glimmer/component)
 *   template:  level-selector.hbs
 *   args:      @setLevel, @dispo
 *   uses:      -
 *   siblings:  list-levels, render-level
 *   tests:     glimmer-actions-test.js, level-selector-writes-test.js
 *
 * Sets/clears a contact's tracked `tmpLevel` and forwards the pick to the host
 * via @setLevel; also toggles a level's sotto_livelli disclosure.
 */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { set } from '@ember/object';

export default class LevelSelectorComponent extends Component {
  // Livelli pieni per questo dispo: capienza (dispo.livelliObj.players_number)
  // <= partecipanti gia' assegnati a quel livello (esclati il partecipante corrente).
  // Usato dal template per disabilitare i livelli senza posti residui.
  get fullSet() {
    const dispo = this.args.dispo || {};
    const caps = {};
    (Array.isArray(dispo.livelliObj) ? dispo.livelliObj : []).forEach((l) => {
      caps[l.livello_name] = l.players_number || 0;
    });
    const used = {};
    (Array.isArray(dispo.partecipanti) ? dispo.partecipanti : []).forEach((p) => {
      if (p === this.args.contact) {
        return;
      }
      const cn = p?.tmpLevel?.colorName;
      if (cn) {
        used[cn] = (used[cn] || 0) + 1;
      }
    });
    const full = {};
    Object.keys(caps).forEach((cn) => {
      if ((used[cn] || 0) >= caps[cn]) {
        full[cn] = true;
      }
    });
    return full;
  }

  @action
  removeColor(contact, event) {
    event.preventDefault();
    set(contact, 'tmpLevel', null);
    this.args.setLevel(contact, this.args?.dispo, null);
  }

  @action
  setColor(contact, level, event) {
    event.preventDefault();
    set(contact, 'tmpLevel', level);
    this.args.setLevel(contact, this.args?.dispo, level);
  }

  @action
  toggleSottoLivelli(level, event) {
    event.preventDefault();
    set(level, 'showSottoLivelli', !level.showSottoLivelli);
  }
}
